/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlAvailableOauthIntegrations = {
    Microsoft: 'microsoft',
    GoogleDirectory: 'google-directory'
} as const;
export type ControlAvailableOauthIntegrations = typeof ControlAvailableOauthIntegrations[keyof typeof ControlAvailableOauthIntegrations];


export function ControlAvailableOauthIntegrationsFromJSON(json: any): ControlAvailableOauthIntegrations {
    return ControlAvailableOauthIntegrationsFromJSONTyped(json, false);
}

export function ControlAvailableOauthIntegrationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAvailableOauthIntegrations {
    return json as ControlAvailableOauthIntegrations;
}

export function ControlAvailableOauthIntegrationsToJSON(value?: ControlAvailableOauthIntegrations | null): any {
    return value as any;
}

